import styled from "styled-components";

const ErrorText = styled.span`
  color: red;
`;

export default ErrorText;
